"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const AddToCart_1 = require("../AddToCart");
const Skeleton_1 = __importDefault(require("../../Skeleton/Skeleton"));
const styled_components_1 = require("styled-components");
const svg_components_1 = require("@/assets/svg-components");
const Typography_1 = require("@/Components/UI/Typography");
const StockAmount = ({ type, stockStatus, isReady, isOrderPrint }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(react_1.default.Fragment, null, stockStatus.map((stock, i) => {
        var _a, _b;
        const columnDirection = !!(stock === null || stock === void 0 ? void 0 : stock.number);
        const colonRule = columnDirection && ((_a = stock === null || stock === void 0 ? void 0 : stock.message) === null || _a === void 0 ? void 0 : _a.at(-1)) !== ':' ? `: ` : '';
        return (react_1.default.createElement(react_1.Fragment, { key: i }, ((_b = stock === null || stock === void 0 ? void 0 : stock.message) === null || _b === void 0 ? void 0 : _b.includes('undefined')) && !isReady ? (react_1.default.createElement(Skeleton_1.default, { marginTop: theme.spacing.s4, fullWidth: true })) : (react_1.default.createElement(styled.StockAmountBlock, { variantType: type, columnDirection: columnDirection, isOrderPrint: isOrderPrint },
            react_1.default.createElement(styled.MessageContainer, null,
                stock.colorStatus === AddToCart_1.ColorStatus.Green ? (react_1.default.createElement(svg_components_1.CheckIcon, null)) : stock.colorStatus === AddToCart_1.ColorStatus.Red ? (react_1.default.createElement(svg_components_1.RedCrossIcon, null)) : (react_1.default.createElement(svg_components_1.YellowCircleIcon, null)),
                react_1.default.createElement(styled.StockStatusMessage, { type: Typography_1.Types.BODY_2 }, stock.message + colonRule)),
            (stock === null || stock === void 0 ? void 0 : stock.number) && (react_1.default.createElement(styled.StockStatusNumber, { type: Typography_1.Types.BODY_2, variantType: type, columnDirection: columnDirection, isOrderPrint: isOrderPrint },
                react_1.default.createElement("a", { href: `tel:${stock.number}` }, stock.number)))))));
    })));
};
exports.default = StockAmount;
